import Resource from './Resource';
import { TYPE, STYLE } from 'Store/reducers/SystemNotificationReducer';
import type AccountProfile from 'App/resources/Model/AccountProfile';

export type ParseOptions = {
	profile: AccountProfile;
	extraCss?: string;
	preview?: boolean;
	skipNotification?: boolean;
};

class InkyParser extends Resource {
	constructor() {
		super('inkyParser');

		this.notifications = {
			parseError: () => ({
				title: 'default.error',
				body: 'error.generateTemplate',
				style: STYLE.ERROR,
				icon: 'times',
				type: TYPE.BODY
			})
		} as any;
	}

	// @ts-expect-error The endpoint is named parse, which collides with Resource's response-parser hook
	parse(markdown: string, options: ParseOptions): Promise<{ data: string }> {
		const { skipNotification, ...params } = options;

		return this._postRequest(
			'parse',
			{ markdown, ...params },
			{ methodName: 'parse', skipErrorNotification: skipNotification }
		).then((res: { data: { data: string } }) => res.data);
	}

	getCss(preview?: boolean): Promise<{ data: string }> {
		return this._getRequest('getCss', {
			methodName: 'getCss',
			params: preview ? { preview: true } : {}
		}).then((res: { data: { data: string } }) => res.data);
	}
}

export default new InkyParser();
